module.exports = __webpack_public_path__ + "static/media/upload_attach.e925f339.svg";